import { useMatch, useNavigate } from "react-router-dom";

import React from "react";

const BreadCrumb = () => {
  let match = useMatch("/cvdetails/:id");
  const navigate = useNavigate();

  return (
    <div
      // style={{ justifyContent: "center", display: "flex", paddingTop: "15px" }}
       style={{ justifyContent: "center", display: "flex" }}
    >
    </div>
  );
};

export default BreadCrumb;
